import { useLanguage } from "@/context/LanguageContext";

export default function TrustBar() {
  const { t } = useLanguage();
  const items = [
    { t: "trust.printing.t", b: "trust.printing.b" },
    { t: "trust.editions.t", b: "trust.editions.b" },
    { t: "trust.france.t", b: "trust.france.b" },
  ];
  return (
    <section
      data-testid="trust-bar"
      className="bg-[#faf8f5] border-y gallery-line"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid grid-cols-1 md:grid-cols-3">
        {items.map((k, i) => (
          <div
            key={k.t}
            className={`py-8 md:py-10 md:px-10 ${
              i > 0 ? "border-t md:border-t-0 md:border-l border-[#111111]/10" : ""
            } ${i === 0 ? "md:pl-0" : ""}`}
          >
            <p className="text-xs uppercase tracking-[0.25em] text-[#111111]">{t(k.t)}</p>
            <p className="mt-3 text-sm font-light leading-relaxed text-[#111111]/60">{t(k.b)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
